export const LayerType = {
  BASE: 'base',
  REGIONS: 'regions',
  NODES: 'nodes',
  VEINS: 'veins',
  SELECTED_POINT: 'selectedPoint'
}

export const LayerVisibility = {
  VISIBLE: 'visible',
  HIDDEN: 'hidden'
}

export class LayerManager {
  constructor() {
    this.map = null
    this.layers = new Map()
    this.visibility = new Map()
  }

  init(map) {
    this.map = map

    Object.values(LayerType).forEach((type) => {
      if (type !== LayerType.BASE) {
        const group = L.layerGroup()
        group.addTo(map)
        this.layers.set(type, group)
        this.visibility.set(type, LayerVisibility.VISIBLE)
      }
    })
  }

  addGeoJSON(layerType, geoJSON, styleOptions = {}, onEachFeature = null) {
    const layerGroup = this.layers.get(layerType)
    if (!layerGroup) return

    const geoJSONLayer = L.geoJSON(geoJSON, {
      style: (feature) => {
        const computed = {}
        for (const [key, value] of Object.entries(styleOptions)) {
          computed[key] = typeof value === 'function' ? value(feature) : value
        }
        return computed
      },
      onEachFeature,
      pointToLayer: (feature, latlng) => {
        const fillColor =
          typeof styleOptions.fillColor === 'function'
            ? styleOptions.fillColor(feature)
            : styleOptions.fillColor || '#ff7800'
        return L.circleMarker(latlng, {
          radius: 8,
          fillColor,
          color: '#fff',
          weight: 2,
          opacity: 1,
          fillOpacity: 0.8
        })
      }
    })

    layerGroup.addLayer(geoJSONLayer)
  }

  toggleLayer(layerType, visible) {
    const layerGroup = this.layers.get(layerType)
    if (!layerGroup) return

    if (visible) {
      this.map.addLayer(layerGroup)
      this.visibility.set(layerType, LayerVisibility.VISIBLE)
    } else {
      this.map.removeLayer(layerGroup)
      this.visibility.set(layerType, LayerVisibility.HIDDEN)
    }
  }

  getVisibility(layerType) {
    return this.visibility.get(layerType) || LayerVisibility.HIDDEN
  }

  clearLayer(layerType) {
    const layerGroup = this.layers.get(layerType)
    if (layerGroup) {
      layerGroup.clearLayers()
    }
  }

  setRegionLayer(geoJSON, getElementColor) {
    this.clearLayer(LayerType.REGIONS)
    this.addGeoJSON(LayerType.REGIONS, geoJSON, {
      fillColor: (feature) => getElementColor(feature),
      weight: 1,
      opacity: 0.5,
      color: '#666',
      dashArray: '3',
      fillOpacity: 0.3
    })
  }
}
